import _ from 'lodash'
import Typography from 'material-ui/Typography'
import moment from 'moment'
import React from 'react'
import WebChatBotChoice from './WebChatBotChoice'
import WebChatChangeUserPlanModal from './WebChatChangeUserPlanModal'
import WebChatChat from './WebChatChat'
import WebChatCreditCardModal from './WebChatCreditCardModal'
import WebChatRegisterRecommendModal from './WebChatRegisterRecommendModal'
import WebChatSend from './WebChatSend'

import chatIcon from 'icon_web_chat.png'

import Dialog from 'material-ui/Dialog'
import images from '../common/images'

import withStyles from 'material-ui/styles/withStyles'
import styleSheet from './AllWebChatStyle.style'

class WebChatChatModal extends React.Component {
  state = {
    chats: [],
    preveous_chats: [],
    answerChoices: [],
  }

  async handleWebChatChatsScroll() {
    const { scrollTop } = this.messageList
    const scrollHeightBefore = this.messageList.scrollHeight
    if (scrollTop === 0) {
      const chats = this.props.stateList.chats
      const preveous_chats = this.state.preveous_chats
      const last_seq_num =
        preveous_chats.length === 0 ? chats[0].attributes.seq_num : preveous_chats[0].attributes.seq_num
      const additional_preveous_chats = await this.props.getChats(last_seq_num)
      this.setState({ preveous_chats: additional_preveous_chats.concat(preveous_chats) }, () => {
        const scrollHeightAfter = this.messageList.scrollHeight
        this.messageList.scrollTo({ top: scrollHeightAfter - scrollHeightBefore })
      })
    }
  }

  async reloadChat(optionUpdateObject = {}) {
    const chats = await this.props.getChats()
    const options = await this.props.getAnswerOptions()
    const freeInputType = 1
    let nurseChatMode,
      freeInputMode = false
    if (!options) nurseChatMode = true
    if (!!options && options[0].answer_type === freeInputType) freeInputMode = true
    if (!options) nurseChatMode = true
    this.setState({ chats: chats, answerChoices: options, nurseChatMode, freeInputMode, ...optionUpdateObject }, () => {
      const { scrollHeight, offsetHeight } = this.messageList
      this.messageList.scrollTo({ top: scrollHeight - offsetHeight })
    })
  }

  update_prev_chats(index) {
    if (index < this.state.preveous_chats.length) {
      const preveous_chats = this.state.preveous_chats.slice()
      preveous_chats[index].attributes.like = !preveous_chats[index].attributes.like
      this.setState({ preveous_chats })
    }
  }

  render() {
    const plan_end_date = moment(this.props.plan_end_date).format('YY/MM/DD')
    const next_reset_date = moment(this.props.next_reset_date).format('YY/MM/DD')
    const preveous_chats = this.state.preveous_chats
    const {
      chats,
      nurseChatMode,
      answerChoices,
      freeInputMode,
      staff_chat_count,
      planChangeModal,
      flag_has_card,
      sp_charge_type,
      userLoggedIn,
      organization_plan,
      chatModal,
      flag_irregular,
      flag_trial_plan,
    } = this.props.stateList
    const inputMode = nurseChatMode || freeInputMode
    const classes = this.props.classes
    const { getPreviousQuestion, can_call_previous_question, current_longitude, current_latitude, can_attach_picture } =
      this.props

    return (
      <Dialog
        PaperProps={{ style: { margin: 0 } }}
        className={classes.paper}
        fullWidth={true}
        open={chatModal}
        onEnter={() => this.reloadChat()}
      >
        <div style={{ overflowX: 'hidden', overflowY: 'scroll' }}>
          <div className={classes.index_chatModalTitle}>
            <b>
              <img src={chatIcon} height={25} width={25} style={{ marginRight: 10 }} />
              チャットで相談
            </b>
            <div
              onClick={() => this.props.onChange('chatModal', !chatModal)}
              className={`${classes.chatModal_closeBtn} btn`}
            >
              ×
            </div>
          </div>
          <div className={classes.index_chatLogs}>
            <div
              className={classes.index_chatScroll}
              ref={(el) => {
                this.messageList = el
              }}
              onScroll={_.throttle((event) => this.handleWebChatChatsScroll(), 500)}
            >
              <WebChatChat
                chats={preveous_chats.concat(chats)}
                clickLikeButton={async (seq_num, is_liked, index) => {
                  this.update_prev_chats(index)
                  await this.props.clickLikeButton(seq_num, is_liked, index)
                }}
              />
            </div>
          </div>
          <div className={classes.chatModal_date}>
            <img src={images.icNurse} height={22} width={22} className={classes.chatModal_nurseImg} />
            看護師相談：<span className={classes.chatModal_dateContent}>残り{staff_chat_count}回&emsp;</span>
            {flag_trial_plan ? null : (
              <span>
                ご利用可能期間：<span className={classes.chatModal_dateContent}>{plan_end_date}まで</span>
              </span>
            )}
          </div>
          <div className={classes.index_chatChoise}>
            {!inputMode ?
              <WebChatBotChoice
                answerChoices={answerChoices}
                sendAnswer={(choice) => {
                  this.props.sendAnswer(choice)
                  this.reloadChat()
                }}
                current_longitude={current_longitude}
                current_latitude={current_latitude}
              />
            : nurseChatMode ?
              <WebChatSend
                reloadChat={() => this.reloadChat()}
                sendMessage={(message, imageUri) => {
                  this.props.sendMessage(message, imageUri)
                  this.reloadChat()
                }}
                can_attach_picture={can_attach_picture}
              />
            : freeInputMode ?
              <WebChatSend
                reloadChat={() => this.reloadChat()}
                sendMessage={(message) => {
                  this.props.sendAnswer(answerChoices[0], message)
                  this.reloadChat()
                }}
                can_attach_picture={can_attach_picture}
              />
            : null}
          </div>
          <div className={`${classes.index_chat_control_btns}`}>
            {can_call_previous_question == true ?
              <div className={`${classes.index_chatPrevious} btn`} onClick={getPreviousQuestion}>
                <div>
                  <Typography className={`mplus-bold ${classes.textBlue}`}>
                    <b>1つ前の選択肢に戻る</b>
                  </Typography>
                </div>
              </div>
            : <div className={`${classes.index_block_previous} btn`}>
                <div>
                  <Typography className={`mplus-bold ${classes.textGray}`}>
                    <b>1つ前の選択肢に戻る</b>
                  </Typography>
                </div>
              </div>
            }

            <div
              className={`${classes.index_chatReset} btn`}
              onClick={() => {
                this.props.resetBotChat()
                this.reloadChat()
              }}
            >
              <div>
                <Typography style={{ width: '50%' }} className={`mplus-bold ${classes.textBlue}`}>
                  <b>チャットを最初からやり直す</b>
                </Typography>
              </div>
            </div>
          </div>
        </div>

        {/* Userが月額プランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示
            Userが法人プランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送信しようとすると表示 */}

        <WebChatCreditCardModal
          planChangeModal={planChangeModal}
          onChange={(fieldName, value) => this.props.onChange(fieldName, value)}
          flag_has_card={flag_has_card}
          sp_charge_type={sp_charge_type}
          next_reset_date={next_reset_date}
          organization_plan={organization_plan}
        />

        {/* ログインしていない状態で、WebChatのURLへとアクセスすると表示する */}

        <WebChatRegisterRecommendModal
          userLoggedIn={userLoggedIn}
          onChange={(fieldName, value) => this.props.onChange(fieldName, value)}
        />

        {/* Userがお試しプランに入会していてかつ、有効期限が切れているときにチャットを送信しようとすると表示
            Userがお試しプランに入会していてかつ、健康相談チャットの残り回数が０の時にメッセージを送ろうとすると表示 */}

        <WebChatChangeUserPlanModal
          planChangeModal={planChangeModal}
          onChange={(fieldName, value) => this.props.onChange(fieldName, value)}
          lag_has_card={flag_has_card}
          sp_charge_type={sp_charge_type}
          organization_plan={organization_plan}
          flag_irregular={flag_irregular}
        />
      </Dialog>
    )
  }
}

export default withStyles(styleSheet)(WebChatChatModal)
